import { ILiveStreamOptions } from 'fitbeat.models';

type translateFn = (key: string, options?: any) => string;

export const footerText = (
  influencerName: string,
  t: translateFn,
  livestreamOptions?: ILiveStreamOptions,
  ): string => {
  if (livestreamOptions?.preWorkoutTalkTopic) {
    return t('InfluencerInviteCardTopic', { name: influencerName })
      + livestreamOptions?.preWorkoutTalkTopic;
  }
  if (livestreamOptions?.preWorkoutTalk) {
    return t('InfluencerInviteCardPreWorkoutTalkNoTopic', { name: influencerName });
  }
  return t('InfluencerInviteCardTrainLiveWith', { name: influencerName });
};

export const cardHeaderText = (
  t: translateFn,
  workoutBooked: boolean = false,
  livestreamOptions?: ILiveStreamOptions,
) => {
  if (livestreamOptions?.preWorkoutTalk) {
    if (workoutBooked) {
      return t('InfluencerInviteCardScheduledTalk');
    }
    return t('InfluencerInviteCardRegisterForTalk');
  }

  if (workoutBooked) {
    return t('InfluencerInviteCardScheduledLive');
  }
  return t('InfluencerInviteCardBookYourSpot');
};
